import React from 'react'

import { ReactComponent as BackDocumentSvg } from 'shared/img/kyc/back-document.svg'
import { ReactComponent as BackDocumentExampleSvg } from 'shared/img/kyc/back-document-example.svg'
import { ReactComponent as DocumentSvg } from 'shared/img/kyc/document.svg'
import { ReactComponent as DriverLicenseSvg } from 'shared/img/kyc/driverLicense.svg'
import { ReactComponent as FrontDocumentExampleSvg } from 'shared/img/kyc/front-document-example.svg'
import { ReactComponent as NationalCardSvg } from 'shared/img/kyc/nationalCard.svg'
import { ReactComponent as PassportSvg } from 'shared/img/kyc/passport.svg'
import { ReactComponent as PassportExampleSvg } from 'shared/img/kyc/passport-example.svg'

import { LocaleProfileType } from 'shared/locale/en-US'
import { DocumentTypes } from 'shared/models/Profile'

export type IDocumentItem = { name: string; value: DocumentTypes; icon: React.FC<React.SVGProps<SVGSVGElement>> }

export const documentsList: IDocumentItem[] = [
  {
    name: 'passport',
    value: DocumentTypes.PASSPORT,
    icon: PassportSvg,
  },
  {
    name: 'driverLicense',
    value: DocumentTypes.DRIVER_LICENSE,
    icon: DriverLicenseSvg,
  },
  {
    name: 'nationalId',
    value: DocumentTypes.NATIONAL_ID,
    icon: NationalCardSvg,
  },
]

export interface IGetDocumentInfo {
  title: string
  subTitle: string
  text: string
  items: {
    name: string
    img: React.FC<React.SVGProps<SVGSVGElement>>
    example?: React.FC<React.SVGProps<SVGSVGElement>>
  }[]
}

export const getDocumentInfo = ({
  document,
  locale,
}: {
  document: IDocumentItem
  locale: LocaleProfileType
}): IGetDocumentInfo => {
  switch (document.value) {
    case DocumentTypes.PASSPORT: {
      return {
        title: locale.uploadPassport,
        subTitle: locale.uploadPassportImage,
        text: locale.pleaseNotRedact,
        items: [
          {
            name: locale.passport,
            img: PassportSvg,
            example: PassportExampleSvg,
          },
        ],
      }
    }
    case DocumentTypes.DRIVER_LICENSE: {
      return {
        title: locale.uploadDriveLicense,
        subTitle: locale.uploadDriveLicenseImage,
        text: locale.pleaseNotRedact,
        items: [
          {
            name: locale.front,
            img: DriverLicenseSvg,
            example: FrontDocumentExampleSvg,
          },
          {
            name: locale.back2,
            img: BackDocumentSvg,
            example: BackDocumentExampleSvg,
          },
        ],
      }
    }
    case DocumentTypes.NATIONAL_ID: {
      return {
        title: locale.uploadNationalIDCard,
        subTitle: locale.uploadNationalIDCardImage,
        text: locale.pleaseNotRedact,
        items: [
          {
            name: locale.front,
            img: NationalCardSvg,
            example: FrontDocumentExampleSvg,
          },
          {
            name: locale.back2,
            img: BackDocumentSvg,
            example: BackDocumentExampleSvg,
          },
        ],
      }
    }
    default: {
      return {
        title: locale.uploadPassport,
        subTitle: locale.uploadPassportImage,
        text: locale.pleaseNotRedact,
        items: [
          {
            name: locale.front,
            img: DocumentSvg,
          },
          {
            name: locale.back,
            img: BackDocumentSvg,
          },
        ],
      }
    }
  }
}

export const initFilesState = {
  front: null,
  back: null,
}
